import values from '../../../res/valuesPhone';
import color from '../../../res/color';

export default {
    main: {
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: color.whiteBackground,
    },
    leftFrame: {
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: color.whiteBackground,
        // opacity: 0,
    },
    title: {
        fontSize: values.fontMax,
        color: color.blackFontColor,
        textAlign: 'center',
        alignSelf: 'center',
        userSelect: "none",
        fontWeight: 'bold',
        fontFamily: 'sans-serif',
    },
    tonoImages: {
        height: '30%',
        width: '90%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-around',
    },
    tono: {
        width: '90%',
        alignSelf: 'center',
        userSelect: "none",
        position: 'relative',
        marginBottom: '10%',
    },
    tonoComment: {
        fontSize: values.fontImage,
        color: color.blackFontColor,
        textAlign: 'center',
        alignSelf: 'center',
        userSelect: "none",
        fontFamily: 'sans-serif',
        fontWeight: 'bold',
    },
    commentBox: {
        height: '40%',
        width: '80%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        backgroundColor: color.lightGrayBackGround,
    },
    commentFrame: {
        height: '100%',
        width: '90%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: color.transparent,
        alignSelf: 'center',
        alignItems: 'center',
        overflow: 'auto',
        overflowY: 'scroll',
        justifyContent: 'center',
    },
    comment: {
        width: '100%',
        fontSize: values.fontMidium,
        color: color.blackFontColor,
        position: 'relative',
        display: 'flex',
        textAlign: 'left',
        marginBottom: '-0.5%',
    },
    commentBold: {
        width: '100%',
        fontSize: values.fontResultBigComment,
        color: color.blackFontColor,
        position: 'relative',
        display: 'flex',
        textAlign: 'left',
        marginBottom: '-0.5%',
        fontWeight: 'bold'
    },
    commentItalic: {
        width: '100%',
        fontSize: values.fontResultBigComment,
        color: color.blackFontColor,
        position: 'relative',
        display: 'flex',
        textAlign: 'left',
        marginBottom: '-0.5%',
        fontStyle: 'italic'
    },
    rightFrame: {
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        overflowY: 'scroll',
    },
    evaluationTitle: {
        textAlign: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: values.fontLarge,
        fontWeight: 'bold',
        color: color.blackFontColor,
        userSelect: "none",
    },
    resultFrame: {
        width: '80%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: color.lightGrayBackGround,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    resultContent: {
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: color.transparent,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    resultLeft: {
        width: '30%',
        backgroundColor: color.transparent,
        paddingLeft: 20,
    },
    resultCircleOut: {
        height: '75px',
        width: '75px',
        borderRadius: '35px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        objectFit: 'cover',
        fontSize: values.fontMediumLarge,
        userSelect: "none",
    },
    resultCircle: {
        height: '55px',
        width: '55px',
        borderRadius: '25px',
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        textAlign: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        objectFit: 'cover',
        margin: 'auto',
        top: 0, bottom: 0, left: 0, right: 0,
        fontSize: values.fontMediumLarge,
        color: color.blackFontColor,
        background: color.lightGrayBackGround,
        userSelect: "none",
    },
    resultValue: {
        position: 'relative',
        fontSize: values.fontLarge,
        fontWeight: 'bold',
        color: color.blackFontColor,
        userSelect: "none",
    },
    resultExtention: {
        fontSize: values.fontMediumLarge,
        color: color.blackFontColor,
        position: 'relative',
        alignSelf: 'bottom',
        alignItems: 'bottom',
        userSelect: "none",
    },
    resultRight: {
        height: '100%',
        width: '60%',
        backgroundColor: color.transparent,
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    resultCommentTitle: {
        textAlign: 'left',
        fontSize: values.fontMediumLarge,
        fontWeight: 'bold',
        color: color.blackFontColor,
        position: 'relative',
        userSelect: "none",
        marginBottom: '-3%',
    },
    resultComment: {
        textAlign: 'center',
        fontSize: values.fontMidium,
        color: color.blackFontColor,
        position: 'relative',
        userSelect: "none",
    },
    reloadFrame: {
        height: '5%',
        display: 'flex',
        flexDirection: 'row',
        position: 'absolute',
        textAlign: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-around',
        top: 1,
        left: '5%',
        margin: 'auto',
    },
    reloadIcon: {
        height: 20,
        width: 20,
        marginRight: 5,
    },
    faqFrame: {
        height: '5%',
        display: 'flex',
        flexDirection: 'row',
        position: 'absolute',
        textAlign: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-around',
        top: 1,
        right: '5%',
        margin: 'auto',
    },
    faqIcon: {
        height: 20,
        width: 20,
        marginRight: 5,
    },
    link: {
        alignSelf: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: "none",
        color: color.blackFontColor,
        textDecoration: "none",
    },
}